<script>
	import { createEventDispatcher } from "svelte";

	import { unformatDate } from "../helpers/dateHelpers";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import TextInput from "./TextInput.svelte";
	import DatePicker from "./DatePicker.svelte";

	export let disabled = null;
	export let numberOfMedicalProviders = 1;
	export let medicalProvider = null;
	export let validator = [];

	const dispatcher = createEventDispatcher();

	const deleteMedicalProviders = () => {
		dispatcher("delete-medical-provider");
	};

	let datesValid = true;
	let dateRageError = null;

	const handleDateChange = (e, type) => {
		if (type == "end") {
			if (!medicalProvider.dateStart || !e.detail.target.value) {
				validator = [];
			} else {
				let d1 = unformatDate(medicalProvider.dateStart);
				let d2 = unformatDate(e.detail.target.value);

				validator = d1 <= d2 ? [] : [dateRageError];
			}
		} else {
			if (!medicalProvider.dateEnd || !e.detail.target.value) {
				validator = [];
			} else {
				let d1 = unformatDate(medicalProvider.dateEnd);
				let d2 = unformatDate(e.detail.target.value);

				validator = d1 >= d2 ? [] : [dateRageError];
				console.log(validator, d1, d2);
			}
		}

		datesValid = validator.length == 0;
	};
</script>

<div class="diagnosis">
	<FormRow class="mt-2">
		<FormColumn cols="3">
			<TextInput
				required
				{disabled}
				placeholder="Medical provider name"
				bind:value={medicalProvider.medicalProviderName}
			/>
		</FormColumn>
		<FormColumn cols="3">
			<TextInput required {disabled} placeholder="Speciality" bind:value={medicalProvider.speciality} />
		</FormColumn>
		<FormColumn cols="3">
			<DatePicker
				required
				{disabled}
				placeholder="From"
				validator={true}
				start={new Date(1950, 0, 1)}
				end={new Date()}
				bind:formattedSelected={medicalProvider.dateStart}
				openOnClass="calendar-icon"
				on:dateChange={(e) => handleDateChange(e, "start")}
			/>
		</FormColumn>
		<FormColumn cols="3">
			<DatePicker
				required
				{disabled}
				placeholder="To"
				validator={true}
				start={new Date(1950, 0, 1)}
				end={new Date()}
				bind:formattedSelected={medicalProvider.dateEnd}
				openOnClass="calendar-icon"
				on:dateChange={(e) => handleDateChange(e, "end")}
			/>
			{#if !datesValid}
				<div class="error-message" bind:this={dateRageError}>The end date must be after the start date</div>
			{/if}
		</FormColumn>
	</FormRow>

	{#if numberOfMedicalProviders > 1}
		<div class="confirmation-hide">
			<button on:click|preventDefault={deleteMedicalProviders} class="delete" title="Delete medical provider">
				<i class="fas fa-trash"></i>
			</button>
		</div>
	{/if}
</div>

<style>
	.diagnosis {
		position: relative;
		margin-right: 40px;
	}

	.delete {
		border: none;
		outline: none;
		background-color: transparent;
		position: absolute;
		top: 10px;
		right: -36px;
		font-size: 1.1rem;
		color: var(--color-primary);
	}
</style>
